/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyFamilyPharmacistLinkTypename = "PharmacyFamilyPharmacistLink" as const;

/**
 *
 * @export
 * @interface PharmacyFamilyPharmacistLink
 */
export interface PharmacyFamilyPharmacistLink {
  /**
   *
   * @type {string}
   * @memberof PharmacyFamilyPharmacistLink
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyFamilyPharmacistLink
   */
  url: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyFamilyPharmacistLink
   */
  readonly __typename?: string;
}

export function PharmacyFamilyPharmacistLinkFromJSON(json: any): PharmacyFamilyPharmacistLink {
  return PharmacyFamilyPharmacistLinkFromJSONTyped(json, false);
}

export function PharmacyFamilyPharmacistLinkFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyFamilyPharmacistLink {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyFamilyPharmacistLinkTypename,

    title: !exists(json, "title") ? undefined : json["title"],
    url: json["url"],
  };
}

export function PharmacyFamilyPharmacistLinkToJSON(object?: PharmacyFamilyPharmacistLink | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    title: value.title,
    url: value.url,
  };
}
